import React from "react";
import Select, { ActionMeta, components, GroupBase, MultiValue, OptionProps, SingleValueProps } from "react-select";
import { toast } from "react-toastify";
import { getMotherTicketTagsClient } from "../../services/api-clients.service";
import { _copyAndSort } from "../../utilities/array.helpers";
import { LogicalOperator, MotherTicketTagResponseModel } from "../../swagger-clients/s365-admin-panel-clients.service";
import BootstrapTooltip from "../bootstrap-tooltip/bootstrap-tooltip";
import { Button } from "react-bootstrap";
import "./mother-ticket-tag-select.scss";
type MotherTicketTagSelectProps = {
    icon?: string;
    iconColor?: string;
    placeholder?: string;
    logicalOperator: LogicalOperator;
    onOperatorChange: (operator: LogicalOperator) => void;
    onChange: (selectedTags?: number[]) => void;
}

export const MotherTicketTagSelect: React.FC<MotherTicketTagSelectProps> = (props) => {
    const [selectedValues, setSelectedValues] = React.useState<ReactSelectTagOption[]>();
    const [tagOptions, setTagOptions] = React.useState<ReactSelectTagOption[]>([]);

    React.useEffect(() => { getMotherTicketTagOptions(); }, []);
    const getMotherTicketTagOptions = async () => {
        try {
            const client = getMotherTicketTagsClient();
            const tags = await client.getTags();
            const sortedTags = sortByParentChild(tags);
            const mappedTags = sortedTags?.map(x => ({ value: x.id, label: x.name, isChild: !!x.parentTagId, icon: x.icon } as ReactSelectTagOption));
            setTagOptions(mappedTags);
        } catch (error) {
            toast.error("An error occurred while getting mother ticket tags.");
        }
    }

    function sortByParentChild(array: MotherTicketTagResponseModel[]) {

        const grouped = array.reduce((acc: any, item) => {
            const parentId = item.parentTagId || 0;
            acc[parentId] = acc[parentId] || [];
            acc[parentId].push(item);
            return acc;
        }, {});

        const sortedArray: MotherTicketTagResponseModel[] = [];

        function addItems(parentId: number) {
            if (!grouped[parentId]) return;
            grouped[parentId].forEach((item: MotherTicketTagResponseModel) => {
                sortedArray.push(item);
                addItems(item.id);
            });
        }

        addItems(0);

        return sortedArray;
    }
    const CustomOption: React.ComponentType<OptionProps<ReactSelectTagOption, true, GroupBase<ReactSelectTagOption>>> = (option) =>
        !option.isDisabled ? (
            <div {...option.innerProps}
                style={{
                    padding: '10px',
                    cursor: 'pointer',
                    backgroundColor: option.isFocused ? '#DEEBFF' : 'white', // Highlight on hover                
                }}>
                <span style={{ paddingLeft: option.data.isChild ? "25px" : undefined }}>{option.data.label}</span>
                {option.data.icon && <span style={{ marginLeft: '5px' }} className={option.data.icon}></span>}
            </div>
        ) : null;


    const CustomSingleValue = ({
        children,
        ...props
    }: SingleValueProps<ReactSelectTagOption>) => (
        <components.SingleValue {...props}>{props.data.label}</components.SingleValue>);

    const onValueChanges = (newValue: MultiValue<ReactSelectTagOption>, actionMeta: ActionMeta<ReactSelectTagOption>) => {

        setSelectedValues(newValue as ReactSelectTagOption[]);

        const value = !!newValue ? newValue.map(x => +x.value) : undefined;
        props.onChange(value);
    }

    const onOperatorChange = () => {
        const operator = props.logicalOperator == LogicalOperator.And ? LogicalOperator.Or : LogicalOperator.And;
        props.onOperatorChange(operator);
    }


    return <div style={{ display: "flex" }}>
         {!!props.icon && <span className="user-tag-select-icon" ><i className={`${props.icon}`} style={{ color: props.iconColor }}></i></span>}
        <BootstrapTooltip tooltipText={<span>
            Logical operator used when filtering multiple selected tags AND or OR.
        </span>} placement="top">
            <Button className="mother-ticket-tag-select-logic-operator-btn" onClick={onOperatorChange}>{props.logicalOperator == LogicalOperator.And ? "AND" : "OR"}</Button>
        </BootstrapTooltip>
        <Select
            value={selectedValues}
            options={tagOptions}
            placeholder={props.placeholder}
            isMulti={true}
            onChange={onValueChanges}
            components={{ Option: CustomOption, SingleValue: CustomSingleValue }}
            isClearable
            styles={{
                container: (provided, props) => { return { ...provided, flex: 1 } },
                control: (provided) => { if (!!props.icon) { return { ...provided, borderBottomLeftRadius: 0, borderTopLeftRadius: 0 } } return provided; }
            }}
        />
    </div>
}

export type ReactSelectTagOption = {
    value: string | number | undefined | null;
    label: string;
    isChild?: boolean;
    icon?: string
    isDisabled?: boolean;
}
